import { styled } from '@mui/material/styles';
import { Typography, Button, Chip } from '@mui/material';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const _palette = clientThemePalette[CLIENT_THEME];

export const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  color: _palette.dark.primary,
  fontWeight: 'bold',
  position: 'relative',
  textDecoration: 'underline dotted',
  textDecorationColor: _palette.dark.primary,
  textDecorationThickness: '2px',
  textUnderlineOffset: '4px',
}));

export const InfoLabel = styled(Typography)(({ theme }) => ({
  // Lightened from #8c96a3 — the labels sit on a dark card and read as
  // disabled at the old value.
  color: '#b8c2d0',
  fontSize: '13px',
  marginBottom: theme.spacing(0.5),
}));

export const InfoValue = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '4px',
  padding: '10px 15px 10px 15px',
  border: `1px solid ${_palette.dark.primary}`,
  color: 'white',
  textTransform: 'none',
  fontSize: '12px',
}));

export const SeverityChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EB5757',
  color: 'white',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0, 1),
  fontSize: '12px',
}));

export const StatusChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EB5757',
  color: 'white',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0, 1),
  fontSize: '12px',
}));
